export const STOCK_FUNDAMENTALS_CHART_TYPE_OPTIONS = ['line', 'bars'];
